
export enum AdminRole {
	ADMIN = "ADMIN",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export interface Admin {
	id: string;
  email: string;
  role: AdminRole;
	isTwoFactorEnabled: boolean;
}

interface AuthInfo {
	tokens: {
			access: string;
	};
	admin: Admin
}

export interface AuthResponse {
	twoFactorRequired: boolean;
	authInfo?: AuthInfo;
}

export interface Auth2FAResponse extends AuthInfo {}
export interface GetUserResponse extends Admin {}